import * as React from "react";
//import { capitalize } from "../engine/Utils";
import { RoundData } from "../engine/RoundData";
import { Player } from "../engine/Player";

export interface IScoreboardProps {
    players: Player[],
    currentPlayer: number,
    pinClasses: String[];
    rounds: RoundData[]
}

export class ScoreboardComponent extends React.Component<IScoreboardProps> {

    getTeamPlayers(teamIndex: number) {
        return this.props.players.
            filter((_, i) => i === (teamIndex) || i === (teamIndex + 2));
    }

    getDrawingTable() {
        let circles = [],
            scored;

        for(let i=1;i<=120;i++) {
            scored = ''
            if(this.props.players[0].score >= i) {
                scored = "scored"
            }
            if(i <= 35 || (i > 45 && i <= 80) || i > 85) {
                circles.push(
                    <span key={`cr-${i}`} className={`circle circle-red-${i} ${scored}`}>&nbsp;</span>
                )
            } else {
                circles.push(
                    <span key={`cr-${i}`} className={`circle curve red red-curve-${i} circle-red-${i} ${scored}`}>&nbsp;</span>
                )
            }
        }

        for(let i=1;i<=120;i++) {
            scored = ''
            if(this.props.players[1].score >= i) {
                scored = "scored"
            }
            if(i <= 35 || (i > 45 && i <= 80) || i > 85) {
                circles.push(
                    <span key={`cb-${i}`} className={`circle circle-blue-${i} ${scored}`}>&nbsp;</span>
                )
            } else {
                circles.push(
                    <span key={`cb-${i}`} className={`circle curve blue blue-curve-${i} circle-blue-${i} ${scored}`}>&nbsp;</span>
                )
            }
        }

        return circles
    }

    public render () {
        const pinClasses = this.props.pinClasses;
        let lines = [];
        for(let i=1;i<=25;i++) {
            lines.push(<span key={i} className={`line-${i}`} >&nbsp;</span>)
        }

        return (
            <div className="scoreboard">
                <div className="board-table">
                    {lines}
                    {this.getDrawingTable()}
                    <span className={`circle red start-red-1`}>&nbsp;</span>
                    <i className={`pin pin-red ${pinClasses[0]}`}>&nbsp;</i>
                    <span className="circle red start-red-2">&nbsp;</span>
                    <i className={`pin pin-red ${pinClasses[1]}`}>&nbsp;</i>
                    <span className="circle blue start-blue-1">&nbsp;</span>
                    <i className={`pin pin-blue ${pinClasses[2]}`}>&nbsp;</i>
                    <span className="circle blue start-blue-2">&nbsp;</span>
                    <i className={`pin pin-blue ${pinClasses[3]}`}>&nbsp;</i>
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/ScoreboardComponent.tsx